"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useItem = void 0;
var _react = require("react");
var _CetComponentsProvider = require("../../../providers/CetComponentsProvider");
var _dates = require("../../../utilities/dates");
var _encoders = require("../../../utilities/encoders");
var _http = require("../../../utilities/http");
var _urls = require("../../../utilities/urls");
var _TaskManager = require("../TaskManager.provider");
var _TaskManager2 = require("../TaskManager.utils");
var _hooks = require("../../../hooks");
const useItem = (itemID, itemLanguage, environmentID, audienceID, taskID, kotarParams, minDate, maxDate, isChangeAudienceAfterSubmitEnabled, isLearningActivity) => {
  const {
    setIsChanged,
    setIsUpdate,
    setTask,
    setOriginalTask,
    setIsTaskLoading,
    setTaskError,
    setReadOnlyGroups,
    setReadOnlyStudents,
    setSelectedGroups,
    setSelectedStudents,
    setIsGroupsReadOnly,
    unitData
  } = (0, _react.useContext)(_TaskManager.TaskManagerContext);
  const {
    schoolId,
    userId
  } = (0, _hooks.useSessionData)();
  const {
    siteKey
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const getTaskTiming = (0, _react.useCallback)((taskType, start, end) => {
    if (taskType === 'selfLearning') {
      start = undefined;
    }
    let nowTime = (start || (minDate ? new Date(Math.max(minDate.getTime(), new Date().getTime())) : new Date())).getTime();
    let startDateTime = new Date(nowTime);
    let endDateTime = end || new Date(nowTime);
    let publishDate = new Date(nowTime);
    let feedbackDate = new Date(nowTime);
    let showFeedback = false;
    let feedbackType = 'immediate';
    if (taskType === 'selfLearning') {
      showFeedback = false;
      endDateTime = maxDate || unitData?.schoolYear.endDate;
    } else if (taskType === 'learningWork') {
      showFeedback = false;
      if (!end || (0, _dates.checkIsEqualTime)(end, startDateTime) <= 0) {
        endDateTime.setDate(startDateTime.getDate() + 7);
      }
      endDateTime.setHours(23, 59, 59, 0);
    } else if (taskType === 'evalWork') {
      showFeedback = true;
      if (!end || (0, _dates.checkIsEqualTime)(end, startDateTime) <= 0) {
        endDateTime.setDate(startDateTime.getDate() + 7);
      }
      endDateTime.setHours(23, 59, 59, 0);
      feedbackDate = new Date(endDateTime.getTime());
      feedbackDate.setDate(feedbackDate.getDate() + 10);
    } else if (taskType === 'exam') {
      showFeedback = true;
      feedbackType = 'afterTeacherComment';
      startDateTime = (0, _dates.restrictToMinuteStep)(startDateTime, 1, true);
      if (!end || (0, _dates.checkIsEqualTime)(end, startDateTime) <= 0) {
        endDateTime = (0, _dates.restrictToMinuteStep)(startDateTime, 1, true);
        endDateTime.setHours(endDateTime.getHours() + 2);
        endDateTime.setSeconds(0);
      }
      feedbackDate = new Date(endDateTime.getTime());
      feedbackDate.setDate(feedbackDate.getDate() + 10);
    } else if (taskType === 'analysis') {
      showFeedback = true;
      feedbackType = 'afterSubmitByAll';
      if (!end) {
        endDateTime.setDate(startDateTime.getDate() + 7);
      }
      endDateTime.setHours(23, 55, 59, 0);
    }
    if (unitData && unitData.schoolYear.endDate) {
      if ((0, _dates.checkIsEqualTime)(startDateTime, unitData.schoolYear.endDate) === 1) {
        startDateTime = (0, _dates.joinDates)(startDateTime, unitData.schoolYear.endDate);
      }
      if ((0, _dates.checkIsEqualTime)(endDateTime, unitData.schoolYear.endDate) === 1) {
        endDateTime = (0, _dates.joinDates)(endDateTime, unitData.schoolYear.endDate);
      }
      if ((0, _dates.checkIsEqualTime)(publishDate, unitData.schoolYear.endDate) === 1) {
        publishDate = (0, _dates.joinDates)(publishDate, unitData.schoolYear.endDate);
      }
      if ((0, _dates.checkIsEqualTime)(feedbackDate, unitData.schoolYear.endDate) === 1) {
        feedbackDate = (0, _dates.joinDates)(feedbackDate, unitData.schoolYear.endDate);
      }
    }
    if (taskType !== 'exam') {
      publishDate.setHours(0, 0, 0, 0);
      feedbackDate.setHours(0, 0, 0, 0);
    }
    startDateTime.setSeconds(0);
    feedbackDate.setSeconds(0);
    publishDate.setSeconds(0);
    return {
      nowTime,
      startDateTime,
      endDateTime,
      publishDate,
      feedbackDate,
      showFeedback,
      feedbackType
    };
  }, [maxDate, minDate, unitData]);
  const isTocTaskOnTheFly = (0, _react.useCallback)((startTime, endTime) => {
    const isHoursDifferenceEqualsUTCDifference = diffHours => {
      const roundedHours = Math.round(diffHours / (1000 * 60 * 60));
      return roundedHours === 3 || roundedHours === 2;
    };
    let isMinDateEqualsStartDate = false;
    let isMaxDateEqualsEndDate = false;
    if (minDate) {
      const diffMin = startTime.getTime() - minDate.getTime();
      isMinDateEqualsStartDate = isHoursDifferenceEqualsUTCDifference(diffMin);
    }
    if (maxDate) {
      const diffMax = endTime.getTime() - maxDate.getTime();
      isMaxDateEqualsEndDate = isHoursDifferenceEqualsUTCDifference(diffMax);
    }
    return isMinDateEqualsStartDate && isMaxDateEqualsEndDate;
  }, [maxDate, minDate]);
  const getLOItem = (0, _react.useCallback)((itemId, itemLang, isStudioItem, studioItemTask) => {
    const id = itemId || studioItemTask && studioItemTask.item && studioItemTask.item.id || itemID;
    const lang = itemLang || studioItemTask && studioItemTask.item && studioItemTask.item.cetLanguage || itemLanguage;
    setIsTaskLoading(true);
    return _http.http.get(`${_urls.ofakimApiUrl}/lmscp/getAuthorizationInfo?itemID=${id}&siteKey=${siteKey}&cultureName=${lang.substring(0, 2).toLowerCase()}`).then(authorizationInfo => {
      if (authorizationInfo && authorizationInfo.isAuthorized) {
        return _http.http.get(`${_urls.ofakimApiUrl}/lmscp/getLOItem?itemID=${id}&cetLanguage=${lang}`);
      } else {
        throw Error('is not authorized');
      }
    }).then(item => {
      if (!isStudioItem) {
        setReadOnlyGroups([]);
        setReadOnlyStudents([]);
        setSelectedGroups([]);
        setSelectedStudents([]);
        setIsGroupsReadOnly(false);
      }
      const taskType = isStudioItem ? studioItemTask.taskType : item && item.isAssessment ? 'evalWork' : 'learningWork';
      const {
        startDateTime,
        endDateTime,
        publishDate,
        feedbackDate,
        feedbackType
      } = getTaskTiming(taskType);
      setTask({
        ...{
          ...(isStudioItem ? studioItemTask : {})
        },
        item: item,
        taskType: taskType,
        name: (0, _encoders.htmlDecode)(studioItemTask && studioItemTask.name && /\S/.test(studioItemTask.name) && studioItemTask.name || kotarParams && kotarParams.title && /\S/.test(kotarParams.title) && kotarParams.title || item && item.name && /\S/.test(item.name) && item.name || ''),
        guideLines: studioItemTask && studioItemTask.guideLines && /\S/.test(studioItemTask.guideLines) && studioItemTask.guideLines || kotarParams && kotarParams.instructions && /\S/.test(kotarParams.instructions) && kotarParams.instructions || item && item.summary && /\S/.test(item.summary) && item.summary || '',
        feedbackType: isStudioItem ? studioItemTask.feedbackType : feedbackType,
        groups: isStudioItem ? studioItemTask.groups : [],
        students: isStudioItem ? studioItemTask.students : [],
        startDateTime: isStudioItem ? studioItemTask.startDateTime : startDateTime,
        endDateTime: isStudioItem ? studioItemTask.endDateTime : endDateTime,
        publishDate: isStudioItem ? studioItemTask.publishDate : publishDate,
        feedbackDate: isStudioItem ? studioItemTask.feedbackDate : feedbackDate,
        hideGrade: isStudioItem ? studioItemTask.hideGrade : true
      });
      setTaskError(false);
      setIsTaskLoading(false);
      setIsChanged(true);
      setIsUpdate(false);
      return item;
    }).catch(error => {
      if (!isStudioItem) {
        setReadOnlyGroups([]);
        setReadOnlyStudents([]);
        setSelectedGroups([]);
        setSelectedStudents([]);
        setIsGroupsReadOnly(false);
      }
      setTask(null);
      setTaskError(error);
      setIsTaskLoading(false);
      setIsChanged(false);
      setIsUpdate(false);
      return error;
    });
  }, [itemID, itemLanguage, setIsTaskLoading, siteKey, getTaskTiming, setTask, kotarParams, setTaskError, setIsChanged, setIsUpdate, setReadOnlyGroups, setReadOnlyStudents, setSelectedGroups, setSelectedStudents, setIsGroupsReadOnly]);
  const getLearningItem = (0, _react.useCallback)(() => {
    setIsTaskLoading(true);
    return _http.http.get(`${_urls.learningUrl}/api/learning-object-snapshot/get-latest/${itemID}`).then(item => {
      setReadOnlyGroups([]);
      setReadOnlyStudents([]);
      setSelectedGroups([]);
      setSelectedStudents([]);
      setIsGroupsReadOnly(false);
      const taskType = item && item.isAssessment ? 'evalWork' : 'learningWork';
      const {
        startDateTime,
        endDateTime,
        publishDate,
        feedbackDate,
        feedbackType
      } = getTaskTiming(taskType);
      setTask({
        item: item,
        taskType: taskType,
        name: item.title || '',
        guideLines: item.metadata?.description || '',
        feedbackType: feedbackType,
        groups: [],
        students: [],
        startDateTime: startDateTime,
        endDateTime: endDateTime,
        publishDate: publishDate,
        feedbackDate: feedbackDate,
        hideGrade: true
      });
      setTaskError(false);
      setIsTaskLoading(false);
      setIsChanged(true);
      setIsUpdate(false);
      return item;
    }).catch(error => {
      setReadOnlyGroups([]);
      setReadOnlyStudents([]);
      setSelectedGroups([]);
      setSelectedStudents([]);
      setIsGroupsReadOnly(false);
      setTask(null);
      setTaskError(error);
      setIsTaskLoading(false);
      setIsChanged(false);
      setIsUpdate(false);
      return error;
    });
  }, [getTaskTiming, itemID, setIsChanged, setIsGroupsReadOnly, setIsTaskLoading, setIsUpdate, setReadOnlyGroups, setReadOnlyStudents, setSelectedGroups, setSelectedStudents, setTask, setTaskError]);
  const getTOCItem = (0, _react.useCallback)(() => {
    setIsTaskLoading(true);
    return _http.http.post(`${_urls.environmentUrl}/Environment/GetTreeItem`, {
      environmentId: environmentID,
      itemID,
      language: itemLanguage
    }).then(item => {
      setReadOnlyGroups([]);
      setReadOnlyStudents([]);
      setSelectedGroups([]);
      setSelectedStudents([]);
      setIsGroupsReadOnly(false);
      const taskType = item && item.isAssessment ? 'exam' : 'selfLearning';
      const {
        startDateTime,
        endDateTime,
        publishDate,
        feedbackDate,
        feedbackType
      } = getTaskTiming(taskType);
      setTask({
        item: item,
        taskType: taskType,
        assignTo: 'all',
        name: (0, _encoders.htmlDecode)(item && item.name && /\S/.test(item.name) && item.name || ''),
        guideLines: item && item.summary && /\S/.test(item.summary) && item.summary || '',
        feedbackType: feedbackType,
        groups: [],
        students: [],
        startDateTime: startDateTime,
        endDateTime: endDateTime,
        publishDate: publishDate,
        feedbackDate: feedbackDate,
        hideGrade: false
      });
      setTaskError(false);
      setIsTaskLoading(false);
      setIsChanged(taskType !== 'selfLearning');
      setIsUpdate(taskType === 'selfLearning');
      return item;
    }).catch(error => {
      setReadOnlyGroups([]);
      setReadOnlyStudents([]);
      setSelectedGroups([]);
      setSelectedStudents([]);
      setIsGroupsReadOnly(false);
      setTask(null);
      setTaskError(error);
      setIsTaskLoading(false);
      setIsChanged(false);
      setIsUpdate(false);
      return error;
    });
  }, [setIsTaskLoading, environmentID, itemID, itemLanguage, setReadOnlyGroups, setReadOnlyStudents, setSelectedGroups, setSelectedStudents, setIsGroupsReadOnly, getTaskTiming, setTask, setTaskError, setIsChanged, setIsUpdate]);
  const getKotarItem = (0, _react.useCallback)(() => {
    const taskType = 'learningWork';
    const {
      startDateTime,
      endDateTime,
      publishDate,
      feedbackDate,
      feedbackType
    } = getTaskTiming(taskType);
    setReadOnlyGroups([]);
    setReadOnlyStudents([]);
    setSelectedGroups([]);
    setSelectedStudents([]);
    setIsGroupsReadOnly(false);
    setTask({
      taskType: taskType,
      name: (0, _encoders.htmlDecode)(kotarParams && kotarParams.title || ''),
      guideLines: kotarParams && kotarParams.instructions || '',
      feedbackType: feedbackType,
      groups: [],
      students: [],
      startDateTime: startDateTime,
      endDateTime: endDateTime,
      publishDate: publishDate,
      feedbackDate: feedbackDate
    });
    setTaskError(false);
    setIsTaskLoading(false);
    setIsChanged(true);
    setIsUpdate(false);
  }, [getTaskTiming, kotarParams, setIsChanged, setIsGroupsReadOnly, setIsUpdate, setReadOnlyGroups, setReadOnlyStudents, setSelectedGroups, setSelectedStudents, setTask, setTaskError, setIsTaskLoading]);
  const getTaskItem = (0, _react.useCallback)(() => {
    setIsTaskLoading(true);
    return _http.http.get(`${_urls.ofakimApiUrl}/lmscp/getTask?taskID=${taskID}&siteKey=${siteKey}`).then(task => {
      const groups = audienceID ? 'audienceGroups' : 'groups';
      const students = audienceID ? 'audienceStudents' : 'students';
      let selectedGroups = [],
        selectedStudents = [],
        readOnlyGroups = [],
        readOnlyStudents = [],
        isGroupsReadOnly = false;
      task.isReadOnly = !!task.isReadOnly;
      task.name = (0, _encoders.htmlDecode)(task.name);
      if (audienceID) {
        task.assignTo = audienceID === task.audienceId ? 'all' : 'some';
      }
      selectedGroups = task.assignTo === 'all' ? [] : task[groups];
      selectedStudents = task.assignTo === 'all' ? [] : task[students];
      if (audienceID && isTocTaskOnTheFly(new Date(task.startDateTime), new Date(task.endDateTime))) {
        const {
          startDateTime,
          endDateTime,
          publishDate,
          feedbackDate,
          feedbackType
        } = getTaskTiming(task.taskType);
        task.startDateTime = startDateTime;
        task.endDateTime = endDateTime;
        task.publishDate = publishDate;
        task.feedbackDate = publishDate;
        task.feedbackDate = feedbackDate;
        task.feedbackType = feedbackType;
      } else {
        task.startDateTime += '';
        task.endDateTime += '';
        task.publishDate += '';
        task.startDateTime = new Date(task.startDateTime);
        task.endDateTime = new Date(task.endDateTime);
        task.publishDate = new Date(task.publishDate);
        if (task.feedbackDate) {
          task.feedbackDate += '';
          task.feedbackDate = new Date(task.feedbackDate);
        }
      }
      if (task.isReadOnly) {
        isGroupsReadOnly = true;
      } else if (task.cannotModifyMembers && !isChangeAudienceAfterSubmitEnabled) {
        readOnlyGroups = task[groups];
        readOnlyStudents = task[students];
      }
      setReadOnlyGroups(readOnlyGroups);
      setReadOnlyStudents(readOnlyStudents);
      setSelectedGroups(selectedGroups);
      setSelectedStudents(selectedStudents);
      setIsGroupsReadOnly(isGroupsReadOnly);
      setTask(task);
      setOriginalTask(task);
      setTaskError(false);
      setIsTaskLoading(false);
      setIsChanged(false);
      setIsUpdate(true);
      return task;
    }).catch(error => {
      setReadOnlyGroups([]);
      setReadOnlyStudents([]);
      setSelectedGroups([]);
      setSelectedStudents([]);
      setIsGroupsReadOnly(false);
      setTask(null);
      setTaskError(error);
      setIsTaskLoading(false);
      setIsChanged(false);
      setIsUpdate(false);
      return error;
    });
  }, [setIsTaskLoading, taskID, siteKey, audienceID, isTocTaskOnTheFly, isChangeAudienceAfterSubmitEnabled, setReadOnlyGroups, setReadOnlyStudents, setSelectedGroups, setSelectedStudents, setIsGroupsReadOnly, setTask, setOriginalTask, setTaskError, setIsChanged, setIsUpdate, getTaskTiming]);
  const getLearningTaskItem = (0, _react.useCallback)(() => {
    setIsTaskLoading(true);
    return Promise.all([_http.http.get(`${_urls.apiGatewayUrl}/lmsapi/Tasks/Get/${taskID}`).then(taskData => taskData || null).catch(error => {
      return null;
    }), _http.http.get(`${_urls.apiGatewayUrl}/lmsapi/Tasks/GetStudentAudience/${taskID}`).then(taskAudience => taskAudience || null).catch(error => {
      return null;
    }), _http.http.get(`${_urls.apiGatewayUrl}/lmsapi/TaskStates/Any/task/${taskID}`).then(hasStarted => hasStarted).catch(error => {
      return null;
    }), _http.http.get(`${_urls.ofakimApiUrl}/lmscp/getUserGroups?schoolID=${schoolId}&userID=${userId}`).then(usersGroups => usersGroups || null).catch(error => {
      return null;
    })]).then(learnigTaskData => {
      const task = (0, _TaskManager2.getLearningTaskData)(learnigTaskData, unitData);
      let selectedGroups = [],
        selectedStudents = [],
        readOnlyGroups = [],
        readOnlyStudents = [],
        isGroupsReadOnly = false;
      selectedGroups = task.groups;
      selectedStudents = task.students;
      if (task.isReadOnly) {
        isGroupsReadOnly = true;
      } else if (task.cannotModifyMembers && !isChangeAudienceAfterSubmitEnabled) {
        readOnlyGroups = task.groups;
        readOnlyStudents = task.students;
      }
      setReadOnlyGroups(readOnlyGroups);
      setReadOnlyStudents(readOnlyStudents);
      setSelectedGroups(selectedGroups);
      setSelectedStudents(selectedStudents);
      setIsGroupsReadOnly(isGroupsReadOnly);
      setTask(task);
      setOriginalTask(task);
      setTaskError(false);
      setIsTaskLoading(false);
      setIsChanged(false);
      setIsUpdate(true);
      return task;
    }).catch(error => {
      setReadOnlyGroups([]);
      setReadOnlyStudents([]);
      setSelectedGroups([]);
      setSelectedStudents([]);
      setIsGroupsReadOnly(false);
      setTask(null);
      setTaskError(error);
      setIsTaskLoading(false);
      setIsChanged(false);
      setIsUpdate(false);
      return error;
    });
  }, [setIsTaskLoading, taskID, schoolId, userId, unitData, isChangeAudienceAfterSubmitEnabled, setReadOnlyGroups, setReadOnlyStudents, setSelectedGroups, setSelectedStudents, setIsGroupsReadOnly, setTask, setOriginalTask, setTaskError, setIsChanged, setIsUpdate]);
  const getEmptyItem = (0, _react.useCallback)(() => {
    const taskType = 'learningWork';
    const {
      startDateTime,
      endDateTime,
      publishDate,
      feedbackDate,
      feedbackType
    } = getTaskTiming(taskType);
    setReadOnlyGroups([]);
    setReadOnlyStudents([]);
    setSelectedGroups([]);
    setSelectedStudents([]);
    setIsGroupsReadOnly(false);
    setTask({
      taskType: taskType,
      name: (0, _encoders.htmlDecode)(''),
      guideLines: '',
      feedbackType: feedbackType,
      groups: [],
      students: [],
      startDateTime: startDateTime,
      endDateTime: endDateTime,
      publishDate: publishDate,
      feedbackDate: feedbackDate,
      hideGrade: true
    });
    setTaskError(false);
    setIsTaskLoading(false);
    setIsChanged(true);
    setIsUpdate(false);
  }, [getTaskTiming, setIsChanged, setIsGroupsReadOnly, setIsUpdate, setReadOnlyGroups, setReadOnlyStudents, setSelectedGroups, setSelectedStudents, setTask, setTaskError, setIsTaskLoading]);
  const getItem = (0, _react.useCallback)(() => {
    if (taskID && siteKey) {
      if (isLearningActivity) {
        if (schoolId && userId) {
          getLearningTaskItem();
        }
      } else {
        getTaskItem();
      }
    } else if (itemID && itemLanguage /*]\ || (task?.task.item && task.item.id && task.item.cetLanguage)*/) {
      if (environmentID) {
        getTOCItem();
      } else if (isLearningActivity) {
        getLearningItem();
      } else {
        getLOItem();
      }
    } else if (kotarParams) {
      getKotarItem();
    } else {
      getEmptyItem();
    }
  }, [environmentID, getEmptyItem, getKotarItem, getLOItem, getLearningItem, getLearningTaskItem, getTOCItem, getTaskItem, isLearningActivity, itemID, itemLanguage, kotarParams, schoolId, siteKey, taskID, userId]);
  return {
    getTaskTiming,
    getLOItem,
    getTOCItem,
    getTaskItem,
    getKotarItem,
    getEmptyItem,
    getItem
  };
};
exports.useItem = useItem;